export default function CheckIcon({ className, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      className={className}
      {...rest}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        d="M4 12l6 6L20 6"
      />
    </svg>
  );
}
